import { CREATE_JOB_POSTING_DEFAULTS } from './constants';

const { TRADE_TYPE_BASIC_HEADER, EMPLOYMENT_TYPE_BASIC_HEADER, EXPERIENCE_LEVEL_BASIC_HEADER, PAY_FREQUENCY_BASIC_HEADER } = CREATE_JOB_POSTING_DEFAULTS;

export const isValidEmail = (value) => {
  return (
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      value
    ) && value.length <= 100
  );
};

export const isServerError = (errorCode) => {
  return (errorCode >= 500 && errorCode <= 599) || errorCode === 20 || errorCode === 1;
};

export const jobPostingValidators = {
  companyName: ({ companyName }) => companyName?.trim() !== '',
  companyUrl: ({ companyUrl = '' }) => {

    if (companyUrl === '' || companyUrl == null) {
      return true;
    }

    let pattern = new RegExp(
      // protocol
      '^(https?:\\/\\/)?'
      // domain name
      + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'
      // OR ip (v4) address
      + '((\\d{1,3}\\.){3}\\d{1,3}))'
      // port and path
      + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'
      // query string
      + '(\\?[;&a-z\\d%_.~+=-]*)?'
      // fragment locator
      + '(\\#[-a-z\\d_]*)?$', 'i');
    return !!pattern.test(companyUrl);
  },
  title: ({ title }) => title?.trim() !== '',
  tradeType: ({ tradeType }) => tradeType !== '' && tradeType !== TRADE_TYPE_BASIC_HEADER,
  employmentType: ({ employmentType }) => employmentType !== '' && employmentType !== EMPLOYMENT_TYPE_BASIC_HEADER,
  yearsOfExperience: ({ yearsOfExperience }) => yearsOfExperience !== '' && yearsOfExperience !== EXPERIENCE_LEVEL_BASIC_HEADER,
  locationText: ({ locationText }) => locationText !== '',
  jobDescription: ({ jobDescription }) => (jobDescription?.trim() !== '<p><br></p>' && jobDescription && jobDescription !== ' '),
  payFrequency: ({ payFrequency }) => payFrequency !== '' && payFrequency !== PAY_FREQUENCY_BASIC_HEADER,
  payRange: ({ payRange }) => {
    if (payRange?.minAmount === '') {
      return false;
    }
    if (!!payRange?.maxAmount && payRange?.minAmount >= payRange?.maxAmount) {
      return false;
    }
    return true;
  },
  minAmount: ({ payRange }) => {
    if (payRange?.minAmount === '') {
      return false;
    }
    let pattern = new RegExp('^\\d+(\\.\\d{1,2})?$');
    return !!pattern.test(payRange?.minAmount) && parseFloat(payRange?.minAmount) > 0;
  },
  maxAmount: ({ payRange }) => {
    let pattern = new RegExp('^\\d+(\\.\\d{1,2})?$');
    return !!pattern.test(payRange?.maxAmount) || payRange?.maxAmount === '' || payRange?.maxAmount === null;
  },
  benefits: ({ benefits }) => {
    return benefits?.choices?.length > 0;
  },
  deadlineToApply: ({ deadlineToApply }) => {
    if (!deadlineToApply || deadlineToApply === '') {
      return true;
    }
    const today = new Date();
    const selectedDate = new Date(deadlineToApply);
    return selectedDate > today;
  }
};

export const jobPostingDraftValidationKeys = ['companyName', 'employmentType', 'jobDescription', 'title', 'tradeType'];
